import _ from 'lodash'
import * as classNames from 'classnames'
import InfiniteScroll from 'react-infinite-scroller'
//import InfiniteScroll from 'react-infinite-scroller'
import React from 'react'
//import * as ReactDOM from 'react-dom'
//export {ToastContainer, toast} from 'react-toastify'

export * from './react-router'
export {StyledProps, ThemedProps} from './mui'

export {React, _, classNames, InfiniteScroll};
export {withStyles} from '@material-ui/core'



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/3rd-party/index.ts